import { environment } from 'src/environments/environment';
 
export class HubServices{

  public static codebuildUrl= environment.SERVER_URL+"hubs/codebuild";
  public static chatUrl=environment.SERVER_URL+"hubs/chat";
  public static hmdcollectorUrl=environment.SERVER_URL+"hubs/hmdcollect";
  //会话列表
  public static API_ConversationList="im/conversationlist";

}
export class ApiService {
  // 登陆
  public static Login = 'service/login/';
  // 菜单
  public static GetMenu = 'service/getmenus/';
  // 忘记密码
  public static ForgetPassword = 'service/forgetpassword/';
  // 发送短信验证码
  public static SendPhoneCode = 'service/sendphonecode/';
  // 个人信息设置
  public static BaseInfoSetting = 'service/baseinfosetting/';
  // 用户列表查询
  public static SearchUsers = 'service/searchusers/';
  //删除用户
  public static DeleteUsers = 'service/deleteusers/';
  // 获取用户基本信息
  public static GetUser = 'service/getuser/';
  // 上传 
  public static UploadFile = environment.aliyunOSS.use ? 'https://' + environment.aliyunOSS.bucket + '.' + environment.aliyunOSS.region + '.aliyuncs.com' : 'streaming/UploadPhysical/';
  //编辑器上传
  public static UeditorUpload=environment.SERVER_URL+'uploadfiles/upload';
  // 日志列表
  public static GetLogList = 'service/getloglist/';
  // 个人中心 修改绑定手机号或邮箱
  public static EditPhoneOrEmail = 'service/editphoneoremail/';
  // 分页获取组织列表
  public static GetOrganizeList = 'service/getorganizelist/';
  // 删除组织
  public static DeleteOrganizes = 'service/deleteorganizes/';
  // 新增/编辑组织
  public static EditOrganizes = 'service/editorganize/';
  // 组织列表
  public static GetOrganizes = 'service/getorganizes/';
  // 部门
  public static GetDepartmentsTree = 'service/getdepartmentstree/';
  // 字段验证
  public static Validatorfieldexist = 'service/validatorfieldexist/';
//验证密码
  public static ValidatorPwd='service/validatorpwd/';
  // 组织名称验证
  public static ValidatorOrgName = 'service/validatororgname/';
  //新增用户
  public static AddUser = 'service/adduser/';
  //禁用或启用用
  public static DisableOrEnableUser = 'service/disableorenableuser/';
  // 验证部门名称
  public static ValidatorDepartmentName = 'service/validatordepartmentname/';
  // 获取指定组织机构和部门树状列
  public static GetDepartmentsAndOrgTree = 'service/getgepartmentsandorgtree/';
  // 编辑部门
  public static EditDepartment = 'service/editdepartment/';
  // 角色列表
  public static GetRoleList = 'service/getrolelist/';
  //角色绑定用户
  public static  RoleUsers='service/roleusers';
  // 编辑角色
  public static EditRole = 'service/eidtrole/';
  // 删除角色
  public static DeleteRole = 'service/deleterole/';
  // 系统菜单列表
  public static GetSysMenuTree = 'service/getsysmenutree';
  // 菜单select数据源
  public static GetSelectMenuTree = 'service/getselectmenutree';
  // 编辑菜单
  public static EditSysMenu = 'service/editsysmenu';
  // 删除菜单
  public static DeleteSysMenus = 'service/deletesysmenus';
  // 删除部门
  public static DeleteDepartments = 'service/deletedepartments';
  // 授权
  public static EditSysAuthorize = 'service/editsysauthorize';
 
  // 个人中心 重置登录密码
  public static ResetPassword = 'service/resetpassword';
  // 获取部门员工
  public static GetMembersByDepartment = 'service/getmembersbydepartment';
  // 将成员移入移除部门
  public static TransferMembers = 'service/transfermembers';
  // 行政区域树状菜单
  public static GetAreasByParentId = 'area/getareasbyparentId';
  // 获取区域列表
  public static GetAreasList = 'area/getareaslist';
  // 新增/编辑区域
  public static EditArea = 'area/editarea';
  // 删除区域
  public static DeleteAreas = 'area/deleteareas';
  //获取区域信息
  public static GetCascaderSource = 'area/getcascadersource';
  //代码生成-获取表信息
  public static SearchSystemTable = 'codebuild/searchsystemtable';

  public static CheckSysUser='codebuild/checksysuser';
  // 代码生成-检测文件目录是否存在
  public static CheckFilePath = 'codebuild/checkfilepath';
  //返回前端Dev目录
  public static getappfolder = 'codebuild/getappfolder';

  //返回数据表字段
  public static getTableField='codebuild/gettablefield';
  //返回数据
  public static gettabledata='codebuild/gettabledata';
  //返回表单字段
  public static getformfield='codebuild/getformfield';

  public static getallcartype='appservice/appcartype/getallcartype';
 
  //加载子表数据源
  public static loaddatasrouces= "service/subdatasroucesquery";
  
}
 